<template>
<div class="chapter">
<div class="inner_page">
<p class="fm12" id="page_19"><strong class="calibre1">F<span class="small">OREWORD</span></strong></p>
<p class="fm13">I think I have met "Ralph Connor." Indeed, I am sure I have—once in a canoe on the Red River, once on the Assinaboine, and twice or three times on the prairies of the West.</p>
<p class="fm13">That was not the name he gave me, of course. But if I am right, it covers one of the most honest and genial of the strong characters that are fighting the devil and doing good work for men all over the world. He has seen with his own eyes the life he describes in this book, and has himself, for some years of hard and lonely toil, assisted in the good influences which he traces among its wild and often hopeless conditions. He writes with the freshness and accuracy of an eyewitness, with the style (as I think his readers will allow) of a real artist, and with the tenderness and hopefulness of a man not only of faith, but of experience, who has seen in fulfillment the ideals for which he lives.</p>
<p class="fm13">The life to which he takes us, though far off and very strange to our tame minds, is the life of our brothers. Into the Northwest of Canada the young men of Great Britain and Ireland have been pouring (I was told) sometimes at the rate of 48,000 a year. Our brothers who left home yesterday—our hearts cannot but follow them.</p>
<p class="fm13">With these pages Ralph Connor enables our eyes and our minds to follow too. Nor do I think there is anyone who <a class="calibre5" id="page_20"></a>shall read this book and not find also that his conscience is quickened. There is a warfare appointed unto man upon earth, and its struggles are nowhere more intense, nor the victories of the strong, nor the succors brought to the fallen, more heroic, than on the fields described in this volume.</p>
<p class="fm15">Professor George Adam Smith, LL.D., 1900</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0007.vue?5aad4cda